module.exports = __webpack_public_path__ + "img/icon_wc_01.51b43c57.png";